const Types = {
  FETCH_IVR_AI_AGENT_FUNCTIONS: '@ivrAIAgent/FETCH_IVR_AI_AGENT_FUNCTIONS',
  FETCH_IVR_AI_AGENT_FUNCTIONS_SUCCESS:
    '@ivrAIAgent/FETCH_IVR_AI_AGENT_FUNCTIONS_SUCCESS',
  FETCH_IVR_AI_AGENT_FUNCTIONS_FAILURE:
    '@ivrAIAgent/FETCH_IVR_AI_AGENT_FUNCTIONS_FAILURE',

  SEARCH_IVR_AI_AGENT_FUNCTIONS: '@ivrAIAgent/SEARCH_IVR_AI_AGENT_FUNCTIONS',
  SEARCH_IVR_AI_AGENT_FUNCTIONS_SUCCESS:
    '@ivrAIAgent/SEARCH_IVR_AI_AGENT_FUNCTIONS_SUCCESS',
  SEARCH_IVR_AI_AGENT_FUNCTIONS_FAILURE:
    '@ivrAIAgent/SEARCH_IVR_AI_AGENT_FUNCTIONS_FAILURE',

  CREATE_IVR_AI_AGENT_FUNCTION: '@ivrAIAgent/CREATE_IVR_AI_AGENT_FUNCTION',
  CREATE_IVR_AI_AGENT_FUNCTION_SUCCESS:
    '@ivrAIAgent/CREATE_IVR_AI_AGENT_FUNCTION_SUCCESS',
  CREATE_IVR_AI_AGENT_FUNCTION_FAILURE:
    '@ivrAIAgent/CREATE_IVR_AI_AGENT_FUNCTION_FAILURE',

  UPDATE_IVR_AI_AGENT_FUNCTION: '@ivrAIAgent/UPDATE_IVR_AI_AGENT_FUNCTION',
  UPDATE_IVR_AI_AGENT_FUNCTION_SUCCESS:
    '@ivrAIAgent/UPDATE_IVR_AI_AGENT_FUNCTION_SUCCESS',
  UPDATE_IVR_AI_AGENT_FUNCTION_FAILURE:
    '@ivrAIAgent/UPDATE_IVR_AI_AGENT_FUNCTION_FAILURE',

  DELETE_IVR_AI_AGENT_FUNCTION: '@ivrAIAgent/DELETE_IVR_AI_AGENT_FUNCTION',
  DELETE_IVR_AI_AGENT_FUNCTION_SUCCESS:
    '@ivrAIAgent/DELETE_IVR_AI_AGENT_FUNCTION_SUCCESS',
  DELETE_IVR_AI_AGENT_FUNCTION_FAILURE:
    '@ivrAIAgent/DELETE_IVR_AI_AGENT_FUNCTION_FAILURE',

  FETCH_IVR_AI_AGENT_INSTRUCTIONS:
    '@ivrAIAgent/FETCH_IVR_AI_AGENT_INSTRUCTIONS',
  FETCH_IVR_AI_AGENT_INSTRUCTIONS_SUCCESS:
    '@ivrAIAgent/FETCH_IVR_AI_AGENT_INSTRUCTIONS_SUCCESS',
  FETCH_IVR_AI_AGENT_INSTRUCTIONS_FAILURE:
    '@ivrAIAgent/FETCH_IVR_AI_AGENT_INSTRUCTIONS_FAILURE',

  SEARCH_IVR_AI_AGENT_INSTRUCTIONS:
    '@ivrAIAgent/SEARCH_IVR_AI_AGENT_INSTRUCTIONS',
  SEARCH_IVR_AI_AGENT_INSTRUCTIONS_SUCCESS:
    '@ivrAIAgent/SEARCH_IVR_AI_AGENT_INSTRUCTIONS_SUCCESS',
  SEARCH_IVR_AI_AGENT_INSTRUCTIONS_FAILURE:
    '@ivrAIAgent/SEARCH_IVR_AI_AGENT_INSTRUCTIONS_FAILURE',

  CREATE_IVR_AI_AGENT_INSTRUCTION:
    '@ivrAIAgent/CREATE_IVR_AI_AGENT_INSTRUCTION',
  CREATE_IVR_AI_AGENT_INSTRUCTION_SUCCESS:
    '@ivrAIAgent/CREATE_IVR_AI_AGENT_INSTRUCTION_SUCCESS',
  CREATE_IVR_AI_AGENT_INSTRUCTION_FAILURE:
    '@ivrAIAgent/CREATE_IVR_AI_AGENT_INSTRUCTION_FAILURE',

  UPDATE_IVR_AI_AGENT_INSTRUCTION:
    '@ivrAIAgent/UPDATE_IVR_AI_AGENT_INSTRUCTION',
  UPDATE_IVR_AI_AGENT_INSTRUCTION_SUCCESS:
    '@ivrAIAgent/UPDATE_IVR_AI_AGENT_INSTRUCTION_SUCCESS',
  UPDATE_IVR_AI_AGENT_INSTRUCTION_FAILURE:
    '@ivrAIAgent/UPDATE_IVR_AI_AGENT_INSTRUCTION_FAILURE',

  DELETE_IVR_AI_AGENT_INSTRUCTION:
    '@ivrAIAgent/DELETE_IVR_AI_AGENT_INSTRUCTION',
  DELETE_IVR_AI_AGENT_INSTRUCTION_SUCCESS:
    '@ivrAIAgent/DELETE_IVR_AI_AGENT_INSTRUCTION_SUCCESS',
  DELETE_IVR_AI_AGENT_INSTRUCTION_FAILURE:
    '@ivrAIAgent/DELETE_IVR_AI_AGENT_INSTRUCTION_FAILURE',
};

export default Types;
